export default __webpack_public_path__ + "static/media/uno.e0c4250c.jpg";